<template>
  <div>
    <div>
      <label class="label-search">Coordenador:</label>
      <autocomplete-z ref="responsavelTypeahead"
              placeholder="Digite o nome do Responsável"
              iconClass="fas fa-users"
              :serializer="(coordenadorId) => coordenadorId.codigo + ' - ' + coordenadorId.nome"
              :debounceLength="3"
              :formField="form.coordenadorId"
              v-on:search="CoordenadorfilterName"
              v-on:changeCode="GetCoordenadorByCode" />
    </div>
    <div class="conteiner">
      <button @click="voltar" class="button-reprova">VOLTAR</button>
      <button @click="enviar" :disabled="this.form.coordenadorId.value == null ? true : false" class="button-save">APROVAR</button>
    </div>
  </div>
</template>

<script>
import addTecnicoViagem from './addTecnicoViagem'
export default addTecnicoViagem
</script>

<style scoped>
.conteiner{
    margin-top: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
}
.button-reprova {
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(168 28 6);
}
.button-save {
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(4, 90, 30);
}
.label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/trevelexpenseemployee/components/addTecnicoViagem/addTecnicoViagem.vue